


function enableScrollAnimation() {
	// スクロールアニメーション対象の要素を取得
	var scrollAnimationElm = document.querySelectorAll('.scroll_up');
  
	// スクロールアニメーション処理を定義
	var scrollAnimationFunc = function scrollAnimationFunc() {
	  for (var i = 0; i < scrollAnimationElm.length; i++) {
		// 要素がビューポートの20%以内に入ったら 'on' クラスを付与
		var triggerMargin = window.innerHeight * 0.2;
		if (window.innerHeight > scrollAnimationElm[i].getBoundingClientRect().top + triggerMargin) {
		  scrollAnimationElm[i].classList.add('on');
		}
	  }
	};
	// ページ読み込み時とスクロール時に処理を実行
	window.addEventListener('load', scrollAnimationFunc);
	window.addEventListener('scroll', scrollAnimationFunc);
  }


//mv パララックス
// function handleScrollEffect() {
// 	const visualInner = document.querySelector('.p-visual__inner');  
// 	// スクロール位置を取得
// 	const scrollPosition = window.pageYOffset;
// 	// '.p-visual__inner' 要素の位置をスクロールに応じて変更
// 	visualInner.style.transform = `translateY(${scrollPosition * -0.2}px)`;
//   }


/*===========================================================*/
/*  印象編 8-6 アルファベットがランダムに変化して出現*/
/*===========================================================*/
// var arr = []
// //初期値の設定
// function TypingInit() {
// 	$('.js_typing').each(function (i) { //js_typingクラスを全て処理をおこなう
// 		arr[i] = new ShuffleText(this);//動作させるテキストを配列に格納
// 	});
// }
// //スクロールした際のアニメーションの設定
// function TypingAnime() {
// 	$(".js_typing").each(function (i) {
// 		var elemPos = $(this).offset().top - 50;//要素より、50px上の
// 		var scroll = $(window).scrollTop();
// 		var windowHeight = $(window).height();
// 		if (scroll >= elemPos - windowHeight) {
// 			if(!$(this).hasClass("endAnime")){//endAnimeのクラスがあるかチェック
// 				arr[i].start();//配列で登録テキストのアニメーションをおこなう
// 				arr[i].duration = 700;//テキストが最終変化するまでの時間※規定値600
// 				$(this).addClass("endAnime");//１度アニメーションした場合はendAnimeクラスを追加
// 			}
// 		}else{
// 			//$(this).removeClass("endAnime"); //範囲外にスクロールした場合はendAnimeのクラスを削除
// 		}
// 	});
// }

//scroll bar
// $(function() {
// 	$('html').scrollgress({//バーの高さの基準となるエリア指定
// 		height: '5px',//バーの高さ
// 		color: '#7764e6',
// 		success: function() {
// 			console.log('Scrollgress has been initiated.');
// 		}
// 	});
// });

// 商品モーダル
$(document).ready(function(){
    // モーダルの表示
    $(".modalBtn").click(function(){
        var index = $(this).data("index");
		$("#modal").fadeIn(200);

		// body要素にoverflow:hiddenを設定してスクロールを禁止
        $("body").css("overflow", "hidden");

        // モーダルが開かれるたびに全ての色情報を非表示にする
        $(".model1, .model2, .model3, .model4").addClass("hide");
        
        // JSONからデータを読み込む
        $.getJSON("./data/data.json", function(data) {
            displayModalContent(data[index]);
        });
    });

    // モーダルの背景をクリックしてモーダルを閉じる
    $("#modal").click(function(event){
        if(event.target.id === "modal"){
			$("#modal").fadeOut(200);
			// body要素のoverflow:hiddenを解除してスクロールを許可
            $("body").css("overflow", "auto");
        }
    });

    // 閉じるボタンがクリックされたときの処理
    $(".close").click(function(){
        //$("#modal").css("display", "none");
		$("#modal").fadeOut(200);
		// body要素のoverflow:hiddenを解除してスクロールを許可
        $("body").css("overflow", "auto");
    });

    // モーダルの内容を表示
    function displayModalContent(data) {
        $(".name").text(data.name);
        $(".text").html(data.text);
        $(".modal__img").attr("src", data.src);
		// JSONデータが存在する場合のみ該当する要素を表示
        if(data.model1) {
            $(".model1").removeClass("hide");
            $(".model1Link").text(data.model1.name).attr("href", data.model1.link);
        }
        if(data.model2) {
            $(".model2").removeClass("hide");
            $(".model2Link").text(data.model2.name).attr("href", data.model2.link);
        }
        if(data.model3) {
            $(".model3").removeClass("hide");
            $(".model3Link").text(data.model3.name).attr("href", data.model3.link);
        }
        if(data.model4) {
            $(".model4").removeClass("hide");
            $(".model4Link").text(data.model4.name).attr("href", data.model4.link);
        }
    }
});


//menu
function toggleNav() {
    $(".l-nav-btn").toggleClass('is-active');
    $(".l-nav-global").toggleClass('is-active');

    // body要素のoverflow設定を切り替える条件分岐
    if ($("body").css("overflow") !== "hidden") {
        $("body").css("overflow", "hidden");
    } else {
        $("body").css("overflow", "auto");
    }
}

$(".l-nav-btn, .l-nav-global__overlay, .l-nav-global__list a").click(function () {
    toggleNav();
});
  


  
//スクロールをしたら実行
$(window).scroll(function () {
//	TypingInit(); // 印象編 8-6 アルファベットがランダムに変化して出現 初期設定
	//TypingAnime();// 印象編 8-6 アルファベットがランダムに変化して出現の関数を呼ぶ
	enableScrollAnimation();
//	handleScrollEffect();
});










// ページが読み込まれたらすぐに動かしたい場合の記述
//$(window).on('load', function () { // onloadはロード時間長いのでやめた
  $(document).ready(function(){    
    /*===========================================================*/
    /*機能編  4-1-3プログレスバー＋数字カウントアップ＋画面が開く*/
    /*===========================================================*/
    
    //テキストのカウントアップ+バーの設定
    var bar = new ProgressBar.Line(splash_text, {//id名を指定
        easing: 'easeOut',//アニメーション効果linear、easeIn、easeOut、easeInOutが指定可能
        duration: 1500,//時間指定(1000＝1秒)
        strokeWidth: 0.1,//進捗ゲージの太さ
        color: '#fff',//進捗ゲージのカラー
        trailWidth: 0.1,//ゲージベースの線の太さ
        trailColor: '#333',//ゲージベースの線のカラー
        text: {//テキストの形状を直接指定				
            style: {//天地中央に配置
                position: 'absolute',
                left: '50%',
                top: '50%',
                padding: '0',
                margin: '-30px 0 0 0',//バーより上に配置
                transform:'translate(-50%,-50%)',
                color: '#fff',
            },
            autoStyleContainer: false //自動付与のスタイルを切る
        },
        step: function(state, bar) {
            var value = Math.round(bar.value() * 100);
            bar.setText(
                value + '<span style="font-size:0.7em;"> %</span>' // %だけ小さく
            );
        }
    });
    
    //プログレスバーのアニメーションスタート
    bar.animate(1.0, function () {

    // ★キラッとクラスを追加
    $("#splash_text").addClass("glint");

        setTimeout(function () {
            $("#splash_text").fadeOut(10); // フェードアウトでローディングテキストを削除
            $(".loader_cover-up").addClass("coveranime"); // カバーが上に上がるクラス追加
            $(".loader_cover-down").addClass("coveranime"); // カバーが下に下がるクラス追加
            // ローディングエリア（splashエリア）をフェードアウトした後に動かすJS
            $("#splash").fadeOut('slow', function () {
                $('body').addClass('appear'); // フェードアウト後 body に appear クラス付与
            });
    
        }, 1200); // ここで1秒待つ
    });
        
  });// ここまでページが読み込まれたらすぐに動かしたい場合の記述











//   $(function() {
//     $(window).on('scroll', function() {
//       $('.anim').each(function() {
//         const scroll = $(window).scrollTop();
//         const elemTop = $(this).offset().top;
//         const windowHeight = $(window).height();
//         const triggerPoint = windowHeight * 0.7; // 画面の60%下の位置で発火（＝40%に入ったら）
  
//         if (scroll > elemTop - triggerPoint) {
//           $(this).addClass('is-animated');
//         }
//       });
//     });
  
//     // 初回読み込み時にも実行
//     $(window).trigger('scroll');
//   });
  




// $(function() {
//     $(window).on('scroll', function() {
//       $('.ttlText').each(function() {
//         const scroll = $(window).scrollTop();
//         const elemTop = $(this).offset().top;
//         const windowHeight = $(window).height();
//         const triggerPoint = windowHeight * 0.7; // 画面の60%下の位置で発火（＝40%に入ったら）
  
//         if (scroll > elemTop - triggerPoint) {
//           $(this).addClass('is-act');
//         }
//       });
//     });
  
//     // 初回読み込みでも実行
//     $(window).trigger('scroll');
//   });





//   $(function() {
//     $(window).on('scroll', function() {
//       $('.p-about__imgItem').each(function() {
//         const scroll = $(window).scrollTop();
//         const elemTop = $(this).offset().top;
//         const windowHeight = $(window).height();
//         const triggerPoint = windowHeight * 0.7; // 画面の60%下の位置で発火（＝40%に入ったら）
  
//         if (scroll > elemTop - triggerPoint) {
//           $(this).addClass('is-active');
//         }
//       });
//     });
  
//     // 初回読み込みでも実行
//     $(window).trigger('scroll');
//   });



//省略ver

$(function() {
  function animateOnScroll(targetSelector, activeClass, triggerRatio = 0.7) {
    $(window).on('scroll', function() {
      const scroll = $(window).scrollTop();
      const windowHeight = $(window).height();
      const triggerPoint = windowHeight * triggerRatio;

      $(targetSelector).each(function() {
        const elemTop = $(this).offset().top;
        if (scroll > elemTop - triggerPoint) {
          $(this).addClass(activeClass);
        }
      });
    });

    // 初回読み込み時にも実行
    $(window).trigger('scroll');
  }

  // 使用例（以下のように1行ずつ呼び出すだけでOK）
  animateOnScroll('.anim', 'is-animated');
  animateOnScroll('.ttlText', 'is-act');
  animateOnScroll('.p-about__imgItem', 'is-active');
});
